import "clsx";
import { p as pop, b as push } from "../../../../chunks/index2.js";
import "../../../../chunks/client.js";
import "../../../../chunks/score.js";
import "../../../../chunks/index3.js";
import { F as Fa } from "../../../../chunks/fa.js";
/* empty css                                                              */
import { faArrowLeft, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import "canvas-confetti";
/* empty css                                                                 */
import { B as Button } from "../../../../chunks/button.js";
function _page($$payload, $$props) {
  push();
  $$payload.out += `<div class="h-full flex flex-col"><header class="flex justify-between items-center h-14 px-6 mb-4 bg-gradient-to-r bg-orange-600/10 backdrop-blur-sm border-b border-orange-500/20 rounded-lg"><div class="flex items-center gap-6"><a href="/" class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-orange-500/20 transition-colors">`;
  Fa($$payload, { icon: faArrowLeft, class: "text-lg" });
  $$payload.out += `<!----></a> <h1 class="text-xl font-bold tracking-tight">Quiz për makinat</h1></div> <div class="flex items-center gap-6">`;
  {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--></div></header> <div class="flex-1 flex flex-col items-center justify-center p-6">`;
  {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div class="text-center"><div class="flex justify-center mb-8"><div class="w-16 h-16 flex items-center justify-center rounded-full bg-orange-500/10">`;
    Fa($$payload, {
      icon: faQuestionCircle,
      class: "text-3xl text-orange-400"
    });
    $$payload.out += `<!----></div></div> <h2 class="text-2xl font-bold mb-4">Testoni njohuritë tuaja për makinat</h2> <p class="text-slate-400 mb-8">Përgjigjuni pyetjeve. Sa më shpejt përgjigjeni, aq më shumë pikë fitoni!</p> `;
    Button($$payload, {
      children: ($$payload2) => {
        $$payload2.out += `<!---->Fillo quizin`;
      },
      $$slots: { default: true }
    });
    $$payload.out += `<!----></div>`;
  }
  $$payload.out += `<!--]--></div></div> `;
  {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--> `;
  {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]-->`;
  pop();
}
export {
  _page as default
};
